<template>
  <div v-if="promoteur && !loading">
    <!-- <spinner-round :isLoading="loading"></spinner-round> -->
    <sticky v-if="promoteur" class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Edition du promoteur {{promoteur.name}}</span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <div class="column is-9 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-border">
          <promoteur-form @submit="submit" :source="promoteur" :loading="loading"></promoteur-form>
        </div>
      </div>
    </div>
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>
</template>

<script>
  import PromoteurForm from '@/components/promoteur/PromoteurForm'

  export default {
    name: 'PromoteurEdit',
    data () {
      return {
        promoteur: null,
        loading: false
      }
    },
    components: {
      PromoteurForm
    },
    methods: {
      loadPromoteur (id) {
        this.loading = true
        this.$api.promoteurService.getOne(id).then(r => {
          this.loading = false
          this.promoteur = r.data
        }).catch(r => {
          this.loading = false
        })
      },
      submit (promoteur) {
        this.loading = true
        this.$api.promoteurService.put(promoteur.pk, promoteur).then(r => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Le promoteur a bien été mis à jour'
          })
          this.$router.push({name: 'PromoteurVue', params: {id: r.data.pk}})
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du promoteur.'
          })
        })
      }
    },
    created () {
      this.loadPromoteur(this.$route.params.id)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurEdit.vue